/**
 * AssetLoadoutCard — Per-asset ordnance loadout display
 */

import type { AssetLoadout } from '../../../types'

interface AssetLoadoutCardProps {
  loadout: AssetLoadout
}

export function AssetLoadoutCard({ loadout }: AssetLoadoutCardProps) {
  const weightPct = loadout.max_weight_lbs > 0
    ? loadout.current_weight_lbs / loadout.max_weight_lbs
    : 0
  const weightColor = weightPct > 0.8 ? '#22c55e' : weightPct > 0.5 ? '#f59e0b' : '#ef4444'
  const filled = Math.round(weightPct * 10)

  return (
    <div className="term-box p-3">
      <div className="flex items-center justify-between mb-2">
        <div className="text-xs font-medium text-term-textDim uppercase tracking-wider">Ordnance Loadout</div>
        <div className="text-[10px] text-term-textDim">
          {loadout.stations_used}/{loadout.stations_total} stations
        </div>
      </div>

      {/* Payload weight bar */}
      <div className="flex items-center gap-2 mb-2">
        <span className="text-[10px] text-term-textDim w-12">Payload</span>
        <div className="flex gap-[1px] flex-1">
          {Array.from({ length: 10 }, (_, i) => (
            <div
              key={i}
              className="h-2.5 flex-1 rounded-sm"
              style={{ backgroundColor: i < filled ? weightColor : '#3a3a5c40' }}
            />
          ))}
        </div>
        <span className="text-[10px] tabular-nums" style={{ color: weightColor }}>
          {(loadout.current_weight_lbs / 1000).toFixed(1)}k / {(loadout.max_weight_lbs / 1000).toFixed(1)}k lbs
        </span>
      </div>

      {/* Station listing */}
      <div className="space-y-1">
        {loadout.current_load.map((item, i) => (
          <div key={i} className="flex items-center justify-between text-[11px]">
            <span className="text-term-text">{item.munition_name}</span>
            <div className="flex items-center gap-2">
              <span className="text-term-textDim tabular-nums">×{item.quantity}</span>
              <span className="text-term-textDim tabular-nums text-[9px]">
                {(item.weight_lbs / 1000).toFixed(1)}k lbs
              </span>
            </div>
          </div>
        ))}
        {loadout.current_load.length === 0 && (
          <div className="text-[10px] text-term-textDim italic">No ordnance loaded</div>
        )}
      </div>
    </div>
  )
}
